interface Props {
  no: string;
  kicker: string;
  title: string;
  sub?: string;
  right?: string;
}

export default function SectionHead({ no, kicker, title, sub, right }: Props) {
  return (
    <div className="flex flex-col gap-4 mb-7">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 border-b-2 border-primary-600 pb-3">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <span className="font-heading text-2xl font-black text-primary-600 leading-none">{no}</span>
            <span className="text-[11px] tracking-[0.3em] text-accent-700 uppercase">{kicker}</span>
            <span className="h-px flex-1 bg-background-300 hidden sm:block" />
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">{title}</h2>
        </div>
        {right && (
          <a href="#rank" className="inline-flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-700 whitespace-nowrap">
            {right} <i className="ri-arrow-right-s-line" />
          </a>
        )}
      </div>
      {sub && <p className="text-sm text-foreground-600 leading-relaxed max-w-3xl">{sub}</p>}
    </div>
  );
}